import React from "react"
import ToolTip from "react-portal-tooltip"
import { IScheduleConstraint } from "../../../models"
import he from "he"
interface IProps {
	constraint: IScheduleConstraint
	orderKey: string
}
interface IState {
	open: boolean
}

export default class ScheduleConstraintDetailCol extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			open: false
		}
	}

	render() {
		return (
			<div style={{ width: "100%", height: "100%" }}>
				<ToolTip active={this.state.open} position="left" arrow="center" parent={`#multilple-${this.props.orderKey}`}>
					<div style={{ padding: "5px 10px", width: 400 }}>
						<div style={{ marginBottom: 5 }}>{this.props.constraint.Title}</div>
						<div>
							{this.props.constraint.Note &&
								<div dangerouslySetInnerHTML={{ __html: he.decode(this.props.constraint.Note) }} />
							}
							{this.props.constraint.NoteList && this.props.constraint.NoteList.map(note =>
								<div dangerouslySetInnerHTML={{ __html: he.decode(note) }} />
							)}
						</div>
					</div>
				</ToolTip>
				<i
					id={`multilple-${this.props.orderKey}`}
					onMouseOver={() => this.setState({ open: true })}
					onMouseOut={() => this.setState({ open: false })}
					className="fa fa-info-circle"
					style={{ color: "#666666", cursor: "pointer", fontSize: 16, marginTop: 5 }}
				/>
			</div >
		)
	}
}
